import { StorageService } from './StorageService';

const plugin = {
  install(vueApp) {
    vueApp.prototype.AulaStorage = new StorageService();
  },
};
export default plugin;
